/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Top_Rated_TitleInputs */

const en_directory_hubs_top_rated_title = /** @type {(inputs: Directory_Hubs_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-rated products`)
};

const zh_directory_hubs_top_rated_title = /** @type {(inputs: Directory_Hubs_Top_Rated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高评分产品`)
};

/**
* | output |
* | --- |
* | "Top-rated products" |
*
* @param {Directory_Hubs_Top_Rated_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_top_rated_title = /** @type {((inputs?: Directory_Hubs_Top_Rated_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Top_Rated_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_top_rated_title(inputs)
	return zh_directory_hubs_top_rated_title(inputs)
});
export { directory_hubs_top_rated_title as "directory.hubs.top-rated.title" }